/**
 * useStoredValueTransactions
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'

import StoredValueTransactionsContext from './stored-value-transactions-context'

const useStoredValueTransactions = () => {
  const context = useContext(StoredValueTransactionsContext)
  return context
}

export default useStoredValueTransactions
